import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import { GenericModalComponent } from './generic-modal.component';
import { SimpleInputComponent } from './simple-input.component'
import { TranslatePipeModule } from '../translate/translate.pipe.module';
@NgModule({
  imports:[
    CommonModule,FormsModule,ReactiveFormsModule,NgxSelectModule,TranslatePipeModule
  ],
  declarations: [
    GenericModalComponent,
    SimpleInputComponent
  ],
  providers: [],
  exports: [ GenericModalComponent,SimpleInputComponent ]
})
export class GenericModalModule {

}
